<template>
    <section class="section">
        <div class="container">
            <h1 class="title is-4">API Exports</h1>

            <div class="columns">
                <div class="column">
                    <form-field is-bulma label="Token">
                        <input-text is-bulma type="text" v-model="token" />
                    </form-field>
                </div>
                <div class="column">
                    <form-field
                        is-bulma
                        label="Sprog"
                        inner-container-class="select is-fullwidth"
                    >
                        <input-select
                            :options="languageOptions"
                            v-model="language"
                            option-value-prop="code"
                            option-title-prop="name"
                        />
                    </form-field>
                </div>
            </div>

            <div class="columns">
                <div class="column">
                    <table class="table is-fullwidth table-fixed">
                        <thead>
                            <tr>
                                <th width="150px">Type</th>
                                <th width="150px">Navn</th>
                                <th>Link</th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr v-for="link in links">
                                <td>{{ link.type }}</td>
                                <td>{{ link.name }}</td>
                                <td>
                                    <a target="_blank" :href="link.link">
                                        {{ link.link }}
                                    </a>
                                </td>
                            </tr>
                        </tbody>
                    </table>
                </div>
            </div>
        </div>
    </section>
</template>

<script>
import { FormField, InputText, InputSelect } from "@elems/form";
import Setting from "./../Setting.vue";

export default {
    components: {
        FormField,
        InputText,
        InputSelect,
        Setting,
    },
    data() {
        return {
            token: "",
            language: "en",
            languageOptions: [
                {
                    code: "da",
                    name: "Dansk",
                },
                {
                    code: "en",
                    name: "Engelsk",
                },
                {
                    code: "sv",
                    name: "Svensk",
                },
            ],
        };
    },
    computed: {
        links() {
            return [
                {
                    type: "SparePartsNow",
                    name: "Items",
                    link: `https://nordicorder.nu/api/sparepartsnow/items?lang=${this.language}&token=${this.token}`,
                },
                {
                    type: "SECO",
                    name: "Items",
                    link: `https://nordicorder.nu/api/seco/items?lang=${this.language}&token=${this.token}`,
                },
                {
                    type: "EU Automation",
                    name: "Items",
                    link: `https://nordicorder.nu/api/euautomation/items?lang=${this.language}&token=${this.token}`,
                },
                {
                    type: "Webshop",
                    name: "Items",
                    link: `https://nordicorder.nu/api/public/items?lang=${this.language}&token=${this.token}`,
                },
                {
                    type: "Webshop",
                    name: "Categories",
                    link: `https://nordicorder.nu/api/public/categories?lang=${this.language}&token=${this.token}`,
                },
                {
                    type: "Webshop",
                    name: "Manufacturers",
                    link: `https://nordicorder.nu/api/public/manufacturers?lang=${this.language}&token=${this.token}`,
                },
                {
                    type: "Webshop",
                    name: "Languages",
                    link: `https://nordicorder.nu/api/public/languages?lang=${this.language}&token=${this.token}`,
                },
            ];
        },
    },
};
</script>
